<template>
  <LinedTextarea
    :id="id"
    :name="name"
    :value="inputValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :error-message="errorMsg"
    :is-error-message-visible="isHasErrorMessage"
    :color="color"
    @input="handleChange"
    @blur="handleBlur"
  />
</template>

<script>
import { useField } from 'vee-validate';

import { LinedTextarea } from '@/components/ui/text-fields';

export default {
	components: { LinedTextarea },
	props: {
		name: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			required: false,
		},
		value: {
			type: String,
			required: false,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		nowrap: [Boolean],
		color: {
			type: String,
			default: 'purple',
			validator (value) {
				return ['purple', 'grey'].includes(value);
			},
		},
	},
	setup (props) {
		const {
			value: inputValue,
			errorMessage,
			handleBlur,
			handleChange,
		} = useField(props?.name || '', undefined, {
			initialValue: props?.value,
		});

		return {
			inputValue,
			handleBlur,
			handleChange,
			errorMessage,
		};
	},
	computed: {
		errorMsg () {
			return this?.errorMessage || '';
		},
		isHasErrorMessage () {
			return !!this.errorMsg;
		},
	},
};
</script>
